"use-strict";

export default {
  all: {},
};
